function InfoIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || "16"}
      height={props.size || "16"}
      viewBox="0 0 16 16"
    >
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.186 0 0 0 0 0.213 0 0 0 0 0.268 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g filter="url(#filter-1)">
          <g fill="#000">
            <path
              id="Path"
              d="M9.958 11.408c-.339 1.305-3.77 1.402-3.529-.339.145-1.16.387-2.271.58-3.432.097-.725-.387-.483-.773-.628-.29-.145-.29-.483.048-.532.435-.096 1.934-.048 2.465-.048.29 0 .435.145.435.387.049.241 0 .483-.048.676-.193 1.112-.483 2.272-.58 3.336-.048.241 0 .677.338.677.339-.049.484-.194.774-.29.193-.097.29.048.29.193zM8.266 3.577c.677 0 1.16.532 1.16 1.16 0 .677-.532 1.209-1.16 1.16-.629 0-1.16-.531-1.16-1.16 0-.628.531-1.16 1.16-1.16z"
            />
            <path
              id="Shape"
              fillRule="nonzero"
              d="M7.976 0C12.423 0 16 3.577 16 7.976A8.004 8.004 0 017.976 16C3.577 16 0 12.423 0 7.976 0 3.577 3.577 0 7.976 0zm0 1.208c-3.722 0-6.768 3.046-6.768 6.768a6.756 6.756 0 006.768 6.767 6.726 6.726 0 006.767-6.767 6.756 6.756 0 00-6.767-6.768z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default InfoIcon;
